export default __webpack_public_path__ + "static/media/auth0.c125074d.svg";